const Sponsors = ({ sponsor_img, sponsor_img_width, t }) => {
  const hasSponsorImg = Boolean(sponsor_img && typeof sponsor_img === "string" && sponsor_img.trim().length > 0);

  if (!hasSponsorImg) return null;

  return (
    <div className="container mt-5 sponsor-container text-center">
      <h4 className="text-capitalize titlenotaligned mb-3">
        {t("concerts.sponsor")}
      </h4>
      <div className="text-center sponsor-img-wrapper">
        <img
          src={sponsor_img}
          alt="Sponsors"
          className="img-fluid rounded_img sponsor-detail-img"
          style={{
            maxWidth: "100%",
            width: sponsor_img_width || "100%",
            height: "auto",
            display: "inline-block",
          }}
          loading="lazy"
          decoding="async"
        />
      </div>
    </div>
  );
};

export default Sponsors;
